import { Card, CardContent, Checkbox, FormControlLabel, Grid, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { IStorageRequest, IStorageRequestProps } from "../../interfaces";
import { FormSectionHeader } from "../Shared/FormSectionHeader";

export const HazardousDeclarationForm: React.FC<IStorageRequestProps> = ({
    storageRequest,
    onUpdate,
    readonly,
    saving,
    ...props
}) => {


    const [model, setModel] = useState<IStorageRequest | null>(storageRequest ?? null);


    useEffect(() => {
        if (storageRequest)
            setModel(storageRequest);
    }, [storageRequest])


    const handleChange = (property: string, value: any) => {
        setModel((prev) => ({
            ...prev,
            [property]: value
        } as IStorageRequest));


        onUpdate(property, value);
    }

    return (
        <>
            <Card sx={{ height: "100%" }} >
                <FormSectionHeader label="Hazardous Declaration" saving={saving} color="warning" />
                <CardContent>

                    <Typography variant="subtitle2">
                        Porterbrook spares storage facilities currently do no have capability to store hazardous material (such as material requiring COSHH cupboard). Any hazardous material that is sent into stores will be rejected upon arrival. Please contact the <a href={"mailto:stores@porterbrook.co.uk"}>stores@porterbrook.co.uk</a>  if you have any uncertainty regarding material you wish to store.
                    </Typography>

                    {model &&
                        <Grid container spacing={2}>
                            <Grid item xs={12} >

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            disabled={readonly}
                                            checked={readonly ? true : (model?.hazardousDeclarationAgreed ?? false)}
                                            onChange={(e) => handleChange("hazardousDeclarationAgreed", e.target.checked)}
                                            required
                                        />
                                    }
                                    label={"I confirm that I am not sending any hazardous material into stores."}
                                />
                            </Grid>

                        </Grid>
                    }
                </CardContent>
            </Card>
        </>
    );
}